import React, { useState } from "react";

import { HeaderPart } from "./component/headerPart";
import { MainPart } from "./component/mainPart";


export const Webhook = () => {

    const [businessAccount, setBusinessAccount] =useState(null);


    return (
        <div>
            <HeaderPart selectedBusinessAccount = {businessAccount} changeBusinessAccount={setBusinessAccount} />
            <MainPart selectedBusinessAccount={businessAccount} />
        </div>
    )
}